import {maybeResourceData} from '@freckle/resource-status'
import {useSafeCallbackExtraDeps} from '@freckle/react-hooks'
import {useCurrentCourse, useSelfStudentDepricated} from '../common/components/with-resources/utils'
import {useApiMutate, useApiQuery} from '../open-api/fancy/client'

// The server parses booleans with Haskell's `Read` instance, which accepts only `True` and `False`
const serializeQuery = (query: Record<string, string | number | boolean>): string =>
  new URLSearchParams(
    Object.entries(query).map(([key, value]) => [
      key,
      typeof value === 'boolean' ? (value ? 'True' : 'False') : String(value)
    ])
  ).toString()

export const useIncompleteAssignmentCount = ({enabled}: {enabled: boolean} = {enabled: true}) => {
  const {selfStudent} = useSelfStudentDepricated()
  const {currentCourse} = useCurrentCourse()
  const student = maybeResourceData(selfStudent)
  const courseId = maybeResourceData(currentCourse)?.id

  return useApiQuery(
    '/3/assignment-count',
    enabled && student && courseId !== undefined
      ? {
          params: {
            query: {
              'student-id': student.id,
              'course-id': courseId,
              'math-standard-set-id': student.mathStandardSet.id,
              incomplete: true,
              unified: false
            }
          },
          querySerializer: serializeQuery
        }
      : null,
    {dedupingInterval: 30_000},
    1
  )
}

export const useInvalidateIncompleteAssignmentCount = () => {
  const mutate = useApiMutate()
  return useSafeCallbackExtraDeps<() => void, {mutate: typeof mutate}>(
    ({mutate}) =>
      () => {
        mutate(['/3/assignment-count'])
      },
    [],
    {
      mutate: {value: mutate, comparator: () => true}
    }
  )
}
